// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1hPU6","selected":"Chip_selected__1Tt6b"};